/*
  assets/glg-launch-runtime-guard.js — READONLY-LAUNCH-DIAGNOSTICS-04
  Updated: 2026-09-10

  Owner: Read-only duplicate asset and active-root diagnostic report.
  Inspected Auth Authority: File Group A -> assets/gcity-auth.js (A09-SHOPIFY-NATIVE-CUSTOMER-ACCOUNT-GUARD-09)

  Activation & Lifecycle:
  - Injected via snippets/frontend-live-qa-diagnostic.liquid when ?gcity_debug=1 or localStorage.gcity_debug=1.
  - Opening Gate is the canonical homepage root; retired Home Shell roots are not queried.

  Boundary:
  - Read-only DOM inspection and script tag counting only.
  - No customer, GFun, checkout, order, tender or external telemetry writes.
*/
(function () {
  'use strict';

  if (window.__GLG_LAUNCH_RUNTIME_GUARD_V3__) return;
  window.__GLG_LAUNCH_RUNTIME_GUARD_V3__ = true;

  var sceneKeys = [
    'cleaner-corner',
    'friendly-walk',
    'safer-campus',
    'brighter-old-district',
    'visible-culture',
    'orderly-low-altitude',
    'safer-waterfront',
    'greener-comfort'
  ];

  /* GCityPartners & LittleG workspace root selectors */
  var roots = [
    '[data-littleg-opening-gate]',
    '[data-home-fixed-workspace="true"]',
    '[data-home-fixed-sidebar="true"]',
    '[data-littleg-city-mission]',
    '[data-gfun-manager]',
    '[data-littleg-dashboard]',
    '[data-littleg-delivery-center]',
    '[data-gcitymap-platform]',
    '[data-gcitypartners-gateway]',
    '.gcitypartners-page-system',
    '[data-gcp-contextual-brief]'
  ];

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function duplicates(nodes, attribute) {
    var counts = {};
    var output = [];
    nodes.forEach(function (node) {
      var value = String(node.getAttribute(attribute) || '').split('?')[0];
      if (value) counts[value] = (counts[value] || 0) + 1;
    });
    Object.keys(counts).forEach(function (key) {
      if (counts[key] > 1) output.push({ asset: key, count: counts[key] });
    });
    return output;
  }

  function storageAvailable() {
    try {
      var key = '__glg_launch_runtime_guard__';
      window.localStorage.setItem(key, key);
      window.localStorage.removeItem(key);
      return true;
    } catch (_) {
      return false;
    }
  }

  function report() {
    var result = {
      version: '72-owner-contract-launch-runtime-v4',
      sceneKeys: sceneKeys,
      timestamp: new Date().toISOString(),
      roots: {},
      duplicateScripts: duplicates(qsa('script[src]'), 'src'),
      duplicateStylesheets: duplicates(qsa('link[rel="stylesheet"][href]'), 'href'),
      hasGCityAuth: !!window.GCityAuth,
      hasGCityExecutor: !!(window.GCityExecutor && typeof window.GCityExecutor.execute === 'function'),
      hasGFunManager: !!window.GFunManager,
      hasGCityPartnersSchema: !!window.GCityPartnersReviewBriefSchema,
      serviceWorkerSupported: 'serviceWorker' in navigator,
      localStorageAvailable: storageAvailable()
    };

    roots.forEach(function (selector) {
      result.roots[selector] = qsa(selector).length;
    });

    window.GLGLaunchRuntime = window.GLGLaunchRuntime || {};
    window.GLGLaunchRuntime.report = result;
    document.documentElement.setAttribute('data-glg-launch-runtime', 'ready');

    try {
      document.dispatchEvent(new CustomEvent('glg:launch-runtime:ready', {
        bubbles: true,
        detail: result
      }));
    } catch (_) {}

    return result;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', report, { once: true });
  } else {
    report();
  }

  document.addEventListener('shopify:section:load', report);
})();